import Share from '../../../../components/share/share.desktop';
import share from './share';

const configuredShare = share(Share);
export default configuredShare;
